module.exports = __webpack_public_path__ + "img/icon_facebook.99e938fb.svg";